import { contexts } from '@/domains'
import useFormatData from '@/domains/hooks/useFormatData'
import { DatePicker, Form, Input, message, Modal, Progress, Select, Upload } from 'antd'
import { observer, useLocalObservable } from 'mobx-react-lite'
import dayjs from 'dayjs'
import moment from 'moment'
import styles from './add.module.less'
import useRequest, { commonReq } from '@/domains/hooks/useLocalRequest'
import ParticipantCard from '@/delivery/components/ParticipantCard'
import { useEffect, useState } from 'react'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { DndProvider } from 'react-dnd' 
import { BugItem } from '@/domains/contexts/BugContext'
import cloneDeep from 'lodash/cloneDeep'
import { PlusOutlined } from '@ant-design/icons'
import { AliOssUtil } from '@/utils/AliOssUtil'
import { OssScene } from '@/global/OssConfig'
import {
  getBugStatusThemeIndex,
  isImg,
  isNetworkUrl,
  isVideo
} from '@/utils/bug'
import FileComp from './File'
import UserIcon from '@/components/UserIcon/UserIcon'
const { Option } = Select
const { BugContext, UserContext, GlobalContext, DeliveryContext } = contexts

type BugAttachment = {
  url: string
  name: string
  isImg: boolean
  isVideo: boolean
  file?: File
}

const revokeBlobUrl = (url: string) => {
  if (url.startsWith('blob:')) {
    URL.revokeObjectURL(url)
  }
}

const serializeAttachments = (imgs: BugAttachment[]) =>
  imgs.map(({ url, name, isImg: imgFlag, isVideo: videoFlag }) => ({
    url,
    name,
    isImg: imgFlag,
    isVideo: videoFlag
  }))

type Props = {
  visible: boolean
  setVisible
  isEdit?: boolean
  item?: BugItem
}
const _form = () => ({
  title: '',
  currentDate: '',
  desc: '',
  status: undefined as number | undefined,
  userIdList: [],
  imgs: [],
  taskId: null
})
const Add = (props: Props) => {
  const { visible, setVisible, isEdit, item } = props
  const { onlyFridayAvailable } = useFormatData()
  const {
    currentDate: gCurrentDate,
    statusList,
    getList,
    tempDeliveryList,
    getTempDeliveryList
  } = BugContext.useContainer()
  const { userInfos, userRecord } = UserContext.useContainer()
  const { userInfo: gUserInfo } = GlobalContext.useContainer()
  const [draggingIndex, setDraggingIndex] = useState<number | null>(null)
  const [submitting, setSubmitting] = useState(false)
  const [uploadPercent, setUploadPercent] = useState(0)
  const [uploadProgressVisible, setUploadProgressVisible] = useState(false)

  const userInfo = gUserInfo || ({} as any)
  const actionName = isEdit ? '编辑' : '添加'
  const store = useLocalObservable(() => ({
    ..._form(),
    currentDate: moment(gCurrentDate)
  }))
  const addReq = useRequest('/sparrowBug/addBug')
  const editReq = useRequest('/sparrowBug/updateBug')
  const onOk = () => {
    if (!store.title) {
      message.error('缺陷的描述不能为空哦！')
      return
    }
    if (store.status == null && statusList[0]) {
      store.status = statusList[0].status
    }
    commonReq(async (handleErr) => {
      setSubmitting(true)
      setUploadPercent(0)
      try {
        const attachments: BugAttachment[] = [...store.imgs]
        const pendingIndexes = attachments
          .map((img, index) =>
            !isNetworkUrl(img.url) && img.file ? index : -1
          )
          .filter((index) => index >= 0)
        const pendingTotal = pendingIndexes.length
        setUploadProgressVisible(pendingTotal > 0)

        for (let step = 0; step < pendingTotal; step++) {
          const index = pendingIndexes[step]
          const attachment = attachments[index]
          const file = attachment.file!
          const ossUrl = await AliOssUtil.uploadFile(
            file,
            OssScene.comment,
            (percent) => {
              const overall = Math.round(
                ((step + percent / 100) / pendingTotal) * 100
              )
              setUploadPercent(overall)
            }
          )
          revokeBlobUrl(attachment.url)
          attachments[index] = {
            ...attachment,
            url: ossUrl,
            file: undefined
          }
        }

        store.imgs = attachments

        const { title, currentDate, status, userIdList, taskId } = store
        let params: any = {
          bugName: title,
          bugStatus: status,
          finishDate: currentDate.format('YYYY-MM-DD 00:00:00'),
          srcUrl: JSON.stringify(serializeAttachments(attachments)),
          userList: userIdList.map((userId) => ({
            userId,
            userType: 1
          }))
        }
        if (taskId) params.taskId = taskId
        if (isEdit) {
          params.id = item.id
          params = {
            updateBugDetailList: [params]
          }
        }
        const res = await (isEdit ? editReq : addReq).run(params)
        if (res.success && res.result) {
          message.success(`${actionName}成功`)
          getList()
          setVisible(false)
        } else {
          handleErr()
        }
      } catch (err) {
        console.error(err)
        message.error('图片上传失败，请稍后重试')
      } finally {
        setSubmitting(false)
        setUploadPercent(0)
        setUploadProgressVisible(false)
      }
    }, `${actionName}失败，清稍后重试`)
  }
  const onDrop = (dragIndex: number, hoverIndex: number) => { 
    const updatedUserInfos = [...store.userIdList];
    const [draggedItem] = updatedUserInfos.splice(dragIndex, 1);
    updatedUserInfos.splice(hoverIndex, 0, draggedItem);
    store.userIdList = updatedUserInfos; 
  };
  // const moveListItem = useCallback(
  //   (dragIndex: number, hoverIndex: number) => {
  //     const userInfos = [...store.userIdList]
  //     const dragItem = store.userIdList[dragIndex]
  //     const hoverItem = store.userIdList[hoverIndex]

  //     userInfos[dragIndex] = hoverItem
  //     userInfos[hoverIndex] = dragItem

  //     store.userIdList = userInfos
  //   },
  //   [store.userIdList]
  // )


  const moveListItem = (dragIndex: number, hoverIndex: number) => { 
 
     // 取出被拖动的元素
     const draggedItem = store.userIdList[dragIndex];
     
     // 从原数组中移除被拖动的元素
     const updatedUserInfos = store.userIdList.filter((item, index) => index !== dragIndex);
     
     // 将被拖动的元素插入新的位置
     updatedUserInfos.splice(hoverIndex, 0, draggedItem);
  
     // 更新状态
     store.userIdList = updatedUserInfos; 
 };

  const addLocalFile = (file: File) => {
    if (store.imgs.length >= 2) {
      message.warning('最多添加 2 张图片')
      return false
    }
    const name =
      file.name ||
      (file.type?.startsWith('image/') ? 'paste.png' : 'attachment')
    const url = URL.createObjectURL(file)
    store.imgs.push({
      url,
      name,
      isImg: file.type ? file.type.startsWith('image/') : isImg(name),
      isVideo: file.type ? file.type.startsWith('video/') : isVideo(name),
      file
    })
    return true
  }

  const handlePaste = (e: ClipboardEvent) => {
    if (!visible || submitting) {
      return
    }
    const { types, files } = e.clipboardData || ({} as DataTransfer)
    if (types?.includes('Files') && files?.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (store.imgs.length >= 2) {
          break
        }
        addLocalFile(files[i])
      }
    }
  }
  useEffect(() => {
    if (!visible) {
      store.imgs.forEach((img) => {
        if (!isNetworkUrl(img.url)) {
          revokeBlobUrl(img.url)
        }
      })
      setSubmitting(false)
      setUploadPercent(0)
      setUploadProgressVisible(false)
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      if (isEdit) {
        const _item: any = cloneDeep(item)
        _item.userList = _item.userList.map((user) => user.id)
        Object.assign(store, _item)
        getTempDeliveryList(_item.onlineDate)
      } else {
        Object.assign(store, {
          ..._form(),
          currentDate: moment(gCurrentDate),
          status: statusList[0]?.status
        })
        getTempDeliveryList(gCurrentDate)
      }
    }
  }, [visible, isEdit, item, gCurrentDate, statusList])
  useEffect(() => {
    document.addEventListener('paste', handlePaste)
    return () => {
      document.removeEventListener('paste', handlePaste)
    }
  }, [visible])
  return (
    <Modal
      open={visible}
      centered
      onCancel={() => !submitting && setVisible(false)}
      title={`${actionName}缺陷`}
      className='add-edit-bug-page'
      width="700px"
      onOk={onOk}
      confirmLoading={submitting}
      okButtonProps={{ disabled: submitting }}
      cancelButtonProps={{ disabled: submitting }}
    >
      {uploadProgressVisible && (
        <div className={styles.uploadProgress}>
          <Progress percent={uploadPercent} size="small" status="active" />
        </div>
      )}
      <DndProvider backend={HTML5Backend}>
        <div className={styles.container}>
          <div className={styles.left}> 
            <Form className='right-form-box'>
              <Form.Item className='description-input-text-area-form'>
                <Input.TextArea
                  placeholder="描述下你发现的问题,CTRL+V可以直接粘贴图片哦。"
                  value={store.title}
                  className='description-input-text-area'
                  onChange={(e) => (store.title = e.target.value)}
                  rows={5}
                ></Input.TextArea>
              </Form.Item>
              <Form.Item>
                <div className={styles.imgContainer}>
                  {store.imgs.map((item, i) => {
                    return (
                      <div key={item.url + i} className={styles.imgWrapper}>
                        <FileComp
                          item={item}
                          action="delete"
                          onAction={() => {
                            revokeBlobUrl(store.imgs[i].url)
                            store.imgs.splice(i, 1)
                          }}
                        ></FileComp>
                      </div>
                    )
                  })}
                  {
                    store.imgs.length < 2 ?  
                    <Upload
                      customRequest={({ file, onSuccess }) => {
                        if (addLocalFile(file as File)) {
                          onSuccess?.({})
                        }
                      }}
                      listType="picture-card"
                      rootClassName="upload-img-box"
                      showUploadList={false}
                      disabled={submitting}
                    >
                      <div >
                        <PlusOutlined /> 
                        {/* <div>图片</div> */}
                      </div>
                    </Upload>
                    :
                    ''
                  }
                </div>
              </Form.Item>
              <Form.Item label="所属交付">
                <Select
                  value={store.taskId}
                  onChange={(e) => (store.taskId = e)}
                  placeholder="请选择周交付"
                  className='no-border-select'
                >
                  {tempDeliveryList.map((item) => {
                    return (
                      <Option key={item.id} value={item.id}>
                        {item.taskName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              <Form.Item label="截止日期" className='date-pick'>
                <DatePicker
                  value={
                    store.currentDate ? dayjs(store.currentDate) : undefined
                  }
                  format="YYYY-MM-DD ddd"
                  disabledDate={onlyFridayAvailable}
                  inputReadOnly
                  className='date-picker' 
                  onChange={(e) => {
                    if (e != null && e.day() !== 5) {
                      return
                    }
                    store.currentDate = e ? moment(e.format('YYYY-MM-DD')) : undefined
                    if (e) {
                      getTempDeliveryList(e.format('YYYY-MM-DD 00:00:00'))
                    }
                  }}
                />
              </Form.Item>
              <Form.Item label="提报人员" style={{marginBottom:0}} >
                <div className='bug-poster'>
                    <UserIcon
                      id={isEdit ? item.fromUser : userInfo.id} 
                      effect='post'
                      showName = {true}
                    ></UserIcon>
                </div> 
              </Form.Item>

            </Form>
          </div>
          <div className={styles.right}>
            <Form labelCol={{ span: 6 }} className='member-select-form'> 
              <Form.Item>
                <Select
                  value={store.status}
                  optionLabelProp="label"
                  onChange={(e) => (store.status = e)}
                  className={`sp-bug-status-select is-${getBugStatusThemeIndex(statusList, store.status)}`}
                >
                  {statusList.map((statusItem, index) => (
                    <Option
                      key={statusItem.status}
                      value={statusItem.status}
                      label={statusItem.name}
                      className={`sp-bug-status-select-item is-${Math.min(index + 1, 6)}`}
                    >
                      {statusItem.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
             
              <Form.Item>
                <Select
                  showSearch
                  className='add-member-select'
                  placeholder="添加参与人"
                  filterOption={(input, option) =>
                    `${userRecord[option.value].userName}${
                      userRecord[option.value].userNamePinyin
                    }${userRecord[option.value].nickname}${
                      userRecord[option.value].userNamePinyin
                    }`
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  } 
                  value={null}
                  onChange={(e) => {
                    store.userIdList = store.userIdList.concat(e)
                  }}
                >
                  {(userInfos || [])
                    .filter(
                      (userInfo) => !store.userIdList.includes(userInfo.id)
                    )
                    .map((userInfo) => (
                      <Select.Option
                        key={userInfo.id}
                        value={userInfo.id}
                      >
                        {userInfo.userName}
                      </Select.Option>
                    ))}
                </Select>
                <div className="member-container">
                  {store.userIdList.map((item, index) => (
                    <ParticipantCard
                      key={item}
                      index={index}
                      userId={item}
                      onDrop={onDrop}
                      moveListItem={moveListItem}
                      onRemove={() => {
                        store.userIdList = store.userIdList.filter(
                          (userId: string): boolean => {
                            return userId !== item
                          }
                        )
                      }}
                      isDragging={index === draggingIndex}
                      onDragStart={() => setDraggingIndex(index)}
                      onDragEnd={() => setDraggingIndex(null)}
                    />
                  ))}
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
      </DndProvider>
    </Modal>
  )
}
export default observer(Add)
